import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';

const CalendarOwnerFilter = ({ selectedIds, onChange }) => {
  const { user } = useAuth();
  const [calendars, setCalendars] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    api.get('/calendar-permissions/').then((response) => {
      const shared = response.data
        .filter((permission) => permission.permitted_user === user.id)
        .map((permission) => ({
          id: String(permission.owner),
          label: permission.owner_name || 'تقویم اشتراکی',
          accessLevel: permission.access_level
        }));
      setCalendars([
        { id: String(user.id), label: 'تقویم من', accessLevel: 'Edit' },
        ...shared.filter((calendar, index, list) => list.findIndex((item) => item.id === calendar.id) === index)
      ]);
    }).catch((error) => console.error('Error fetching shared calendars:', error));
  }, [user?.id]);

  const toggleCalendar = (id) => {
    const next = selectedIds.includes(id)
      ? selectedIds.filter((selectedId) => selectedId !== id)
      : [...selectedIds, id];
    onChange(next.length ? next : [String(user.id)]);
  };

  const selectedLabels = calendars.filter((calendar) => selectedIds.includes(calendar.id)).map((calendar) => calendar.label);
  const selectedText = selectedLabels.length === 1
    ? selectedLabels[0]
    : selectedLabels.length > 1
      ? `${selectedLabels.length} تقویم انتخاب شده`
      : 'انتخاب تقویم‌ها';

  return (
    <div className="relative w-[220px] shrink-0">
      <button type="button" onClick={() => setOpen((value) => !value)} className="w-full h-10 bg-white border border-slate-300 rounded-xl px-3 flex items-center gap-2 text-sm font-bold text-right shadow-sm hover:border-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-100">
        <span className="flex-1 truncate">{selectedText}</span>
        <span className={`text-slate-400 text-xs transition-transform ${open ? 'rotate-180' : ''}`}>⌄</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-full bg-white border border-slate-200 rounded-xl shadow-2xl p-2">
          <div className="px-2 py-1.5 mb-1 border-b border-slate-100 text-[11px] font-bold text-slate-500">انتخاب تقویم‌ها</div>
          {calendars.map((calendar) => (
            <label key={calendar.id} className="flex items-center gap-2 min-h-9 px-2 rounded-lg hover:bg-slate-50 cursor-pointer text-xs">
              <input className="h-4 w-4 shrink-0 accent-indigo-600" type="checkbox" checked={selectedIds.includes(calendar.id)} onChange={() => toggleCalendar(calendar.id)} />
              <span className="flex-1 min-w-0 truncate font-semibold text-slate-700">{calendar.label}</span>
              {calendar.id !== String(user?.id) && <span className="shrink-0 text-[10px] text-slate-400">{calendar.accessLevel === 'Edit' ? 'ویرایش' : 'مشاهده'}</span>}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default CalendarOwnerFilter;
